import cn from 'clsx'

import { FaTrash } from 'react-icons/fa'

const TemplatePlaceholdersTable = ({
    className,
    template,
    isInternalTemplate,
    setPendingDeletePlaceholder,
}) => {
    
    return (
        
        <table className={cn(
            'TemplatePlaceholdersTable',
            'w-full table-auto Template-placeholders-table',
            className,
        )}>
            <thead>
                <tr>
                    <th>Key</th>
                    <th>Value</th>
                    <th>{/* Actions */}</th>
                </tr>
            </thead>
            <tbody>
                {template?.placeholders?.map(it => (
                    <tr key={`template-${it.id}`}>
                        <td>{it.key}</td>
                        <td>{it.value}</td>
                        <td>
                            <div className="flex items-center content-center justify-end">
                                {!isInternalTemplate && (
                                    <button
                                        className="w-auto text-red-800 btn btn-link hover:text-red-500"
                                        title="Delete Placeholder"
                                        onClick={() => setPendingDeletePlaceholder(it)}>
                                        <FaTrash />
                                    </button>
                                )}
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        
    )
    
}

export default TemplatePlaceholdersTable
